// A lot of these utilities are from another module called ramda-extension
// When enough of these are placed here it's propbably best to remove this file
// and replace with the ramda-extensions dependency.
import {
  compose,
  constructN,
  equals,
  isEmpty,
  isNil,
  join,
  map,
  reject,
  split,
  toLower,
} from 'ramda'

const EMPTY_STRING = ''

export const constructRegExp = constructN(2, RegExp)

export const NON_ALPHA_NUMERIC_REG_EXP = constructRegExp(/[^a-zA-Z0-9]+/, 'g')

export const isNilOrEmpty = (value: any): value is null | undefined =>
  isNil(value) || isEmpty(value)

export const joinWithDash = join('-')

export const keyBy = <T>(entities: T[], id: string) =>
  entities.reduce((acc, entity) => {
    acc[entity[id]] = entity
    return acc
  }, {})

export const splitByNonAlphaNumeric = compose(
  reject(equals(EMPTY_STRING)),
  split(NON_ALPHA_NUMERIC_REG_EXP)
)

export const toKebabCase = compose(
  joinWithDash,
  compose(map(toLower), splitByNonAlphaNumeric)
)
